import React from "react";

export default function ItemStars({ title, feedback }) {
  return (
    <>
      <div>
        <span className="green bold width-65 inline-block">{title}</span>
        <span className="bold inline-block width-25">{feedback.value}</span>
        <span className="nowrap">
          {[...Array(5)].map((value, index) => (
            <i
              key={`start-${index}`}
              className={`fa fa-lg fa-star ${
                feedback.round_value >= index + 1 ? "active" : ""
              }`}
            ></i>
          ))}
        </span>
      </div>
    </>
  );
}
